module.exports = __webpack_public_path__ + "img/eat2.449c6280.png";